import React from "react";
import "./PageLoaderStyle.css";

const PageLoader = () => {
  return (
    <div className="preloader-wrapper">
      <div className="dotsLoader" role="status" aria-label="Loading">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default PageLoader;
